export default __webpack_public_path__ + "static/martin_bw-8a41a70e3f3fb3b38cfb6bd779ed5a3c.png";